import { Input, Directive } from '@angular/core';
import { ComponentBase, Changeable } from "common";
import { FormBuilder, UntypedFormGroup, FormControl, Validators, ValidatorFn } from '@angular/forms';
import { MonitorPolicy, MonitorPolicyEditor } from 'DiscoveryEngine.TS/Monitors';


@Directive()
export abstract class MonitorConfigComponentBase extends ComponentBase implements Changeable  {

	@Input()
	public editor: MonitorPolicyEditor;

	@Input()
	public visible: boolean;

	public SettingsForm: UntypedFormGroup;

	constructor() {
		super();

		this.editor = null;
		this.visible = false;
	}

	public abstract BuildForm(): void;

	public get tempChanges(): boolean {
		return this.SettingsForm.dirty;
	}

	public get tempChangesValid(): boolean {
		return this.SettingsForm.valid;
	}

	public abstract get invalidTempChanges(): string[];

	public abstract applyTempChanges(): void;

	public discardTempChanges(): void {
		this.BuildForm();
	}

}